import { render, staticRenderFns } from "./PlanOptions.vue?vue&type=template&id=2bc12b26"
import script from "./PlanOptions.vue?vue&type=script&lang=js"
export * from "./PlanOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports